// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"102":"async-webviz-subsurface-viewer","329":"async-webviz-view-footer","742":"async-webviz-group-tree","824":"async-webviz-well-log-viewer"}[chunkId] + ".js";
};